import script from "./TopTab.vue?vue&type=script&setup=true&lang=js"
export * from "./TopTab.vue?vue&type=script&setup=true&lang=js"

import "./TopTab.vue?vue&type=style&index=0&id=501adc9b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-501adc9b"]])

export default __exports__